import {ListItem} from "@domain/common/list-view/list-item";
import {User} from "@domain/user/user";
import {HistoriqueEnveloppeChange} from "./historique-enveloppe-change";

/**
 * Historique pour une enveloppe
 */
export class HistoriqueEnveloppe implements ListItem {
    id: number;

    nature: TypeNature;

    idEnveloppe: number;

    idLog: number;

    acteur: User;

    dateLog: Date;

    typeLog: TypeLog;

    sourceLog: TypeSource;

    reference: string;

    listeHistoriqueEnveloppeChange: HistoriqueEnveloppeChange[];

    getKey(): number {
        return this.id;
    }
}

/** Enumération des types de modification */
export enum TypeLog {
    AJOUT = 1,
    MODIFICATION = 2,
    SUPPRESSION = 3
}

/** Enumération des types de source */
export enum TypeSource {
    ADMINISTRATEUR = 1,
    IMPORT = 2,
    UTILISATEUR = 3
}

/** Enumération des natures des historiques des enveloppes */
export enum TypeNature {
    ENVELOPPE = 1,
    ANALYTIQUE = 2,
    MONTANT = 3,
    REAFFECTATION = 4
}
